import { createSlice } from '@reduxjs/toolkit';
import { IndicatorGroup, IndicatorGroupState } from './indicatorgroupTypes';
import { createIndicatorGroup , fetchAllIndicatorGroup , updateIndicatorGroup,deleteIndicatorGroup , fetchIndicatorGroupById } from './indicatorgroupAction';


const initialState : IndicatorGroupState = {
    indicatorgroup : [],
    selectedindicatorgroup : undefined,
    loadingStates : {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },

}

const indicatorgroupSlice = createSlice({
    name : 'indicatorgroup',
    initialState,
    reducers:{},
    extraReducers : (builder) =>{
        builder
            .addCase(createIndicatorGroup.pending, (state) => {
                                              state.loadingStates.create = true;
                                              state.errors.create = undefined;
                                          })
                                          .addCase(createIndicatorGroup.fulfilled, (state, action) => {
                                              state.loadingStates.create = false;
                                              state.indicatorgroup.push(action.payload);
                                          })
                                          .addCase(createIndicatorGroup.rejected, (state, action) => {
                                              state.loadingStates.create = false;
                                              state.errors.create = action.payload as string;
                                          })
                              
                                          // Update 
                                          .addCase(updateIndicatorGroup .pending, (state) => {
                                              state.loadingStates.update = true;
                                              state.errors.update = undefined;
                                          })
                                          .addCase(updateIndicatorGroup .fulfilled, (state, action) => {
                                              state.loadingStates.update = false;
                                              const index = state.indicatorgroup.findIndex((d : any) => d.Id === action.payload.Id);
                                              if (index !== -1) {
                                                  state.indicatorgroup[index] = action.payload;
                                              }
                                          })
                                          .addCase(updateIndicatorGroup .rejected, (state, action) => {
                                              state.loadingStates.update = false;
                                              state.errors.update = action.payload as string;
                                          })
                              
                                          // Delete 
                                          .addCase(deleteIndicatorGroup.pending, (state) => {
                                              state.loadingStates.delete = true;
                                              state.errors.delete = undefined;
                                          })
                                          .addCase(deleteIndicatorGroup.fulfilled, (state, action) => {
                                              state.loadingStates.delete = false;
                                              state.indicatorgroup = state.indicatorgroup.filter((d : any) => d.Id !== action.payload);
                                          })
                                          .addCase(deleteIndicatorGroup.rejected, (state, action) => {
                                              state.loadingStates.delete = false;
                                              state.errors.delete = action.payload as string;
                                          })
                              
                                          // Fetch  by ID
                                          .addCase(fetchIndicatorGroupById.pending, (state) => {
                                              state.loadingStates.fetchById = true;
                                              state.errors.fetchById = undefined;
                                          })
                                          .addCase(fetchIndicatorGroupById.fulfilled, (state, action) => {
                                              state.loadingStates.fetchById = false;
                                              state.selectedindicatorgroup = action.payload;
                                          })
                                          .addCase(fetchIndicatorGroupById.rejected, (state, action) => {
                                              state.loadingStates.fetchById = false;
                                              state.errors.fetchById = action.payload as string;
                                          })
                              
                                          // Fetch All 
                                          .addCase(fetchAllIndicatorGroup.pending, (state) => {
                                              state.loadingStates.fetchAll = true;
                                              state.errors.fetchAll = undefined;
                                          })
                                          .addCase(fetchAllIndicatorGroup.fulfilled, (state, action) => {
                                              state.loadingStates.fetchAll = false;
                                              state.indicatorgroup = action.payload.data;
                                          })
                                          .addCase(fetchAllIndicatorGroup.rejected, (state, action) => {
                                              state.loadingStates.fetchAll = false;
                                              state.errors.fetchAll = action.payload as string;
                                          }); 
    }
})


export default indicatorgroupSlice.reducer;